var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2659_9325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6636 0.774969L12.6645 0.775813L17.5395 5.67444C17.9047 6.04142 17.9033 6.635 17.5363 7.0003C17.1693 7.36555 16.5758 7.36414 16.2105 6.99716L12.9375 3.70822L12.9375 23.5625C12.9375 24.0803 12.5178 24.5 12 24.5C11.4822 24.5 11.0625 24.0803 11.0625 23.5625L11.0625 3.70827L7.7895 6.99711C7.42425 7.3641 6.83067 7.3655 6.46369 7.00025C6.09661 6.63495 6.09535 6.04133 6.4605 5.67439L11.3355 0.775766L11.3364 0.774922C11.7029 0.40775 12.2984 0.408922 12.6636 0.774969Z",
    fill: "#34D3B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2659_9325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24.5) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.0fc6cc7344a0905baa12a3f23eb4727f.svg";
export { ForwardRef as ReactComponent };